import SidebarTopPatients from "./SidebarTopPatients";

export default SidebarTopPatients;